// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "NotFoundPage" + "." + "49dda3ab" + ".chunk.css";
};